/**
 * Shared Footer for HomePage, FAQs, and other public pages.
 * Uses HomePage.css for consistent styling.
 */

import { Link } from 'react-router-dom'
import './HomePage.css'

const Footer = () => (
  <footer className="home-footer">
    <div className="home-container home-footer-container">
      <div className="home-footer-left">
        <h3 className="home-footer-brand"><span className="home-text-blue">O</span><span className="home-text-purple">n</span><span className="home-text-orange">e</span> Globe Alliance</h3>
        <p className="home-footer-description">
          A unified global community for independent freight forwarders, driving business growth across borders.
        </p>
      </div>
      <div className="home-footer-links">
        <div className="home-footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/#about">About Us</Link></li>
            <li><Link to="/#membership">Membership</Link></li>
            <li><Link to="/#events">Events</Link></li>
            <li><Link to="/faqs">FAQs</Link></li>
          </ul>
        </div>
        <div className="home-footer-column">
          <h4>Contact</h4>
          <a href="mailto:info@oneglobealliance.com" className="home-footer-email">info@oneglobealliance.com</a>
          <a href="tel:+919892105006" className="home-footer-email">+91 989-210-5006</a>
        </div>
      </div>
    </div>
    <div className="home-footer-bottom">
      <div className="home-container home-footer-bottom-inner">
        <p className="home-footer-copyright">© 2025 ONE Globe Alliance. All rights reserved.</p>
        <div className="home-footer-links-bottom">
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  </footer>
)

export default Footer
